import { render, staticRenderFns } from "./home_intergral.vue?vue&type=template&id=71dfe74a&scoped=true"
import script from "./home_intergral.vue?vue&type=script&lang=js"
export * from "./home_intergral.vue?vue&type=script&lang=js"
import style0 from "./home_intergral.vue?vue&type=style&index=0&id=71dfe74a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dfe74a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71dfe74a')) {
      api.createRecord('71dfe74a', component.options)
    } else {
      api.reload('71dfe74a', component.options)
    }
    module.hot.accept("./home_intergral.vue?vue&type=template&id=71dfe74a&scoped=true", function () {
      api.rerender('71dfe74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_intergral.vue"
export default component.exports